import * as loginActions from './actions';
import * as appActions from '../app/actions';
import {Record} from 'immutable';

const State = Record({
    formDisabled: false
});

const FORM_DISABLED = 'formDisabled';

const loginReducer = (state = new State(), action) => {

    switch (action.type) {

        case appActions.SET_ERROR_OFFLINE:
        case loginActions.API_LOGIN_ERROR:
        case loginActions.API_LOGIN_PIN_ERROR: {
            return state.set(FORM_DISABLED, false);
        }
        case loginActions.API_LOGIN_START:
        case loginActions.API_LOGIN_PIN_START: {
            return state.set(FORM_DISABLED, true);
        }
        case loginActions.API_LOGIN_SUCCESS:
        case loginActions.API_LOGIN_PIN_SUCCESS: {
            return state.set(FORM_DISABLED, false);
        }
    }

    return state;
};

export default loginReducer;



// WEBPACK FOOTER //
// ./src/common/login/reducer.js